<template>
  <svg
    width="144"
    height="155"
    viewBox="0 0 144 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60.6063 120.387C93.6823 120.387 120.496 93.6219 120.496 60.6049C120.496 27.5879 93.6823 0.822266 60.6063 0.822266C27.5302 0.822266 0.716797 27.5879 0.716797 60.6049C0.716797 93.6219 27.5302 120.387 60.6063 120.387Z"
      fill="#EAEEF9"
    />
    <path
      d="M31.9887 85.6915C31.2759 85.6915 30.596 85.5496 29.9746 85.293L29.593 86.2174C28.0601 85.5846 26.8273 84.3655 26.1846 82.8478L27.1055 82.4579C26.8439 81.8401 26.6992 81.1639 26.6992 80.4552V77.9739H25.6992V73.0112H26.6992V68.0485H25.6992V63.0859H26.6992V58.1232H25.6992V53.1605H26.6992V48.1979H25.6992V43.2352H26.6992V40.7539C26.6992 40.0452 26.8439 39.369 27.1055 38.7512L26.1846 38.3612C26.8273 36.8436 28.0601 35.6245 29.593 34.9917L29.9746 35.916C30.596 35.6595 31.2759 35.5176 31.9887 35.5176H34.4063V34.5176H39.2415V35.5176H44.0767V34.5176H48.9119V35.5176H53.7471V34.5176H58.5823V35.5176H63.4175V34.5176H68.2527V35.5176H73.0879V34.5176H77.9231V35.5176H82.7583V34.5176H87.5935V35.5176H90.0112C90.7239 35.5176 91.4039 35.6595 92.0252 35.916L92.4068 34.9917C93.9397 35.6245 95.1726 36.8436 95.8152 38.3612L94.8943 38.7512C95.156 39.369 95.3006 40.0452 95.3006 40.7539V43.2407H96.3006V48.2143H95.3006V53.188H96.3006V58.1616H95.3006V63.1353H96.3006V68.1089H95.3006V73.0826H96.3006V78.0562H95.3006V80.5431C95.3006 81.2579 95.1589 81.9314 94.903 82.5408L95.825 82.928C95.1903 84.4393 93.9629 85.6356 92.4041 86.2464L92.0393 85.3153C91.4228 85.5569 90.7399 85.6915 90.0112 85.6915H87.5936V86.6915H82.7583V85.6915H77.9231V86.6915H73.0879V85.6915H68.2527V86.6915H63.4175V85.6915H58.5823V86.6915H53.7471V85.6915H48.9119V86.6915H44.0767V85.6915H39.2415V86.6915H34.4063V85.6915H31.9887Z"
      fill="#D5DDEA"
      stroke="#989FB0"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-dasharray="5.01 5.01"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.0254 65.9577C55.0254 65.3127 55.573 64.7898 56.2485 64.7898H66.8364C67.5119 64.7898 68.0595 65.3127 68.0595 65.9577C68.0595 66.6027 67.5119 67.1256 66.8364 67.1256H56.2485C55.573 67.1256 55.0254 66.6027 55.0254 65.9577Z"
      fill="#989FB0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.4976 52.2472C62.1731 52.2472 62.7207 52.77 62.7207 53.4151V61.6356C62.7207 62.2806 62.1731 62.8035 61.4976 62.8035C60.8221 62.8035 60.2745 62.2806 60.2745 61.6356V53.4151C60.2745 52.77 60.8221 52.2472 61.4976 52.2472Z"
      fill="#989FB0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.6342 52.2492C61.1087 51.7972 61.8759 51.7941 62.3544 52.2423L67.6929 57.2424C68.1751 57.6941 68.1826 58.4335 67.7096 58.894C67.2366 59.3545 66.4622 59.3616 65.98 58.91L61.5052 54.7188L57.1122 58.9031C56.634 59.3586 55.8596 59.3577 55.3825 58.901C54.9055 58.4443 54.9065 57.7049 55.3847 57.2493L60.6342 52.2492Z"
      fill="#989FB0"
    />
    <g filter="url(#filter0_d_6635_202997)">
      <path
        d="M115.358 121.177H60.7143C57.4606 121.177 54.791 118.512 54.791 115.264V77.5396C54.791 74.2918 57.4606 71.627 60.7143 71.627H115.358C118.612 71.627 121.282 74.2918 121.282 77.5396V115.264C121.282 118.512 118.612 121.177 115.358 121.177Z"
        fill="url(#paint0_linear_6635_202997)"
      />
    </g>
    <path
      d="M92.4997 93.8611C93.6516 93.8611 94.5854 92.929 94.5854 91.7792C94.5854 90.6294 93.6516 89.6973 92.4997 89.6973C91.3478 89.6973 90.4141 90.6294 90.4141 91.7792C90.4141 92.929 91.3478 93.8611 92.4997 93.8611Z"
      fill="#C2C8D6"
    />
    <path
      d="M92.8328 104.938H77.3156C76.3144 104.938 75.7305 103.772 76.3145 103.023L84.0731 92.1969C84.5736 91.5307 85.5747 91.5307 86.0753 92.1969L93.8339 103.023C94.4179 103.856 93.8339 104.938 92.8328 104.938Z"
      fill="#C2C8D6"
    />
    <path
      opacity="0.7"
      d="M98.1729 104.771H91.5822C90.5811 104.771 90.0806 103.689 90.5811 102.939L93.8347 98.359C94.3353 97.6928 95.253 97.6928 95.7536 98.359L99.0072 102.939C99.758 103.689 99.174 104.771 98.1729 104.771Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d_6635_202997"
        x="32.791"
        y="60.627"
        width="110.49"
        height="93.5508"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6635_202997"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6635_202997"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6635_202997"
        x1="88.0146"
        y1="70.4808"
        x2="88.0146"
        y2="121.711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
